module.exports = __webpack_public_path__ + "assets/img/exit-fullscreen.c0a0b5af.svg";